import { array, assign, boolean, integer, nullable, object, optional, pick, string, trimmed } from 'superstruct';
import { EditPermissionsDto } from '@arc/shared/util-data';
import { ViewRoleListedDto } from '@arc/shared/util-roles';
import { stringDate } from '@arc/shared/util-superstruct';
export const ViewUserDto = object({
  id: integer(),
  name: trimmed(string()),
  phone: nullable(string()),
  email: string(),
  superuser: boolean(),
  lastLoggedInAt: nullable(stringDate()),
  createdAt: stringDate(),
  archived: boolean(),
  isLocked: optional(boolean())
});
export const ViewUserListedDto = assign(ViewUserDto, object({
  roles: array(ViewRoleListedDto)
}));

/**
 * Use this dto when loading user information on another entity
 * e.g. customer's agents or quote's createdBy
 */
export const ViewUserInfoDto = pick(ViewUserDto, ['id', 'name', 'email', 'phone', 'superuser', 'lastLoggedInAt', 'archived']);
export const ViewAuthUserDto = assign(pick(ViewUserDto, ['id', 'name', 'phone', 'email', 'superuser', 'lastLoggedInAt', 'archived', 'createdAt']), object({
  permissions: EditPermissionsDto
}));
export function authUserToActor(user) {
  return {
    type: 'User',
    userId: user.id,
    userName: user.name
  };
}